import { EventEmitter } from "../../components/event-emitter";
import { Stack } from "./stack";
import { IHistoryProvider } from "./interfaces/history-provider.interface";
import { IHistoryState } from "./interfaces/history-state.interface";

declare global {
  interface History {
    onpushstate: (e: { state: any }) => void
    onreplacestate: (e: { state: any }) => void
  }
}

export class HistoryProvider implements IHistoryProvider {
  constructor(public readonly stack: Stack<IHistoryState | null>) {

    window.addEventListener('popstate', event => {
      this.stack.popstate(event.state);
      this.eventEmitter.emit("popstate", event);
    });

    const pushState = history.pushState;
    history.pushState = function(state) {
      if (typeof history.onpushstate == "function") {
        history.onpushstate({ state: state });
      }
      return pushState.apply(history, arguments);
    };

    const replaceState = history.replaceState;
    history.replaceState = function(state) {
      if (typeof history.onreplacestate == "function") {
        history.onreplacestate({ state: state });
      }
      return replaceState.apply(history, arguments);
    };

    history.onpushstate = (e) => {
      this.stack.push(e.state);
      this.eventEmitter.emit("pushstate", e);
    }

    history.onreplacestate = (e) => {
      this.stack.replace(e.state); 
      this.eventEmitter.emit("replacestate", e);
    }
  }

  private eventEmitter = new EventEmitter<"popstate" | "pushstate" | "replacestate">();

  public getCurrentState(): IHistoryState {
    return history.state;
  }

  public add(state: Omit<IHistoryState, "namespace">) {
    const newState = { ...state, namespace: "dentolo_quiz" };
    history.pushState(newState, '');
  }

  public replace(scene: Omit<IHistoryState, "namespace"> | null) {
    let state: any = scene;
    if (scene) state = { ...state, namespace: "dentolo_quiz" };
    history.replaceState(state, '');
  }

  public back() {
    history.back();
    this.stack.back();
  }

  public forward() {
    history.forward();
    this.stack.forward();
  }

  public onpopstate(callback: (event: PopStateEvent) => void) {
    this.eventEmitter.subscribe("popstate", callback);
  }

  public onpushstate(callback: (event: PopStateEvent) => void) {
    this.eventEmitter.subscribe("pushstate", callback);
  }
}